import React from 'react';

export default () => (
  <footer>
    <div className="box">
      <div id="dash-legal">
        <p id="copy" style={{ color: '#aaa' }}>
          © {new Date().getFullYear()} Registered Sleepers, Inc
        </p>
        <p id="version" style={{ color: '#aaa' }}>Version 2.0a</p>
      </div>
    </div>
  </footer>
);



// WEBPACK FOOTER //
// ./src/views/global/footer.js